import { parseAttribution } from './conversionPayload'

const COOKIE_MAX_AGE = 60 * 60 * 24 * 30

const hasDocument = () => typeof document !== 'undefined'

export const convCookies = {
  get(name) {
    if (!hasDocument()) return null
    const pair = document.cookie
      .split(';')
      .map((entry) => entry.trim())
      .find((entry) => entry.startsWith(`${name}=`))
    if (!pair) return null
    // cookie 為外部可寫狀態:不合法 percent escape 會使 decodeURIComponent 拋 URIError,壞值視為不存在
    try {
      return decodeURIComponent(pair.slice(name.length + 1)) || null
    } catch {
      return null
    }
  },
  set(name, value, { maxAge = COOKIE_MAX_AGE } = {}) {
    if (!hasDocument()) return
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}`
  },
  remove(name) {
    if (!hasDocument()) return
    document.cookie = `${name}=; path=/; max-age=0`
  },
}

export const captureConversionAttribution = (searchOrFullPath, cookies = convCookies) => {
  const { traceId, vendorCode, ac, price } = parseAttribution(searchOrFullPath)
  if (!traceId && !ac) return

  if (traceId) {
    cookies.set('conv_trace_id', traceId)
    cookies.set('conv_vendor', vendorCode)
    cookies.set('conv_captured_at', String(Math.floor(Date.now() / 1000)))
    if (price) {
      cookies.set('conv_price', price)
    } else {
      cookies.remove('conv_price')
    }
    if (!ac) {
      cookies.remove('conv_ac')
    }
  }
  if (ac) {
    cookies.set('conv_ac', ac)
  }
}

export const readLaunchAttribution = (cookies = convCookies) => {
  const capturedAtRaw = cookies.get('conv_captured_at')
  return {
    traceId: cookies.get('conv_trace_id') || undefined,
    vendorCode: cookies.get('conv_vendor') || undefined,
    capturedAt: capturedAtRaw ? Number(capturedAtRaw) : undefined,
    ac: cookies.get('conv_ac') || undefined,
    price: cookies.get('conv_price') || undefined,
  }
}
